import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { twMerge } from 'tailwind-merge';
import { MatError } from '@angular/material/form-field';

export type errorTextSize = 'base' | 'sm';

@Component({
  selector: 'pm-error-message',
  imports: [TranslatePipe],
  template: `<h6 class="{{ cssClass() }}">{{ message() | translate }}</h6>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorMessageComponent {
  protected sizeMap = {
    base: 'text-base', // 16px
    sm: 'text-sm', // 14px
  };

  // MatError color is different at the moment and overwrite this
  private readonly isMatError = inject(MatError, { optional: true });

  public readonly message = input<string>('UTILITY.ERROR_OCCURRED');
  public readonly size = input<errorTextSize>('base');

  public cssClass = computed(() => {
    return twMerge([
      this.isMatError ? '' : 'text-critical-500',
      this.sizeMap[this.size()],
    ]);
  });
}
